import React from 'react';
import Box from "@material-ui/core/Box";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useStyles } from "./style";

const CheckBoxFilter = ({
  label,
  onChange,
  options,
  value,
  width
}) => {

  const classes = useStyles();

  return (
    <Box className={classes.selectorBox}>
      <Box width={width}>
        <h4
          data-cy="filter-lbl"
          id="filter-lbl"
        >
          {label}
        </h4>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={value.some(item => item.label === options[0].label)}
                color="primary"
                data-cy="option0-chk"
                id="option0-chk"
                name={options[0].value}
                onChange={onChange}
              />
            }
            data-cy="option0-lbl"
            id="option0-lbl"
            label={options[0].label}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={value.some(item => item.label === options[1].label)}
                color="primary"
                data-cy="option1-chk"
                id="option1-chk"
                name={options[1].value}
                onChange={onChange}
              />
            }
            data-cy="option1-lbl"
            id="option1-lbl"
            label={options[1].label}
          />
        </FormGroup>
      </Box>
    </Box>
  );
};

export default CheckBoxFilter;
